// The order list's status filter, shared by the order table and the new-order
// badge (both read localStorage "orderStatusFilter").

export const ORDER_STATUS_FILTER_KEY = "orderStatusFilter";

export const DEFAULT_ORDER_STATUS_FILTER = [
  "REVIEW",
  "PROCESSING",
  "SHIPPING",
  "COMPLETE",
  "UNPAID",
];

const SHIPPING_ADDED_KEY = "orderStatusFilterShippingAdded";

/** SHIPPING is new (Shipmondo v1). A filter saved before it existed would hide
 *  every order being shipped, so it is added once to any saved filter that
 *  shows PROCESSING. Unticking it afterwards sticks. */
export const addShippingToSavedFilter = () => {
  try {
    if (localStorage.getItem(SHIPPING_ADDED_KEY)) return;
    localStorage.setItem(SHIPPING_ADDED_KEY, "1");
    const saved = localStorage.getItem(ORDER_STATUS_FILTER_KEY);
    if (!saved) return;
    const filter = JSON.parse(saved);
    if (
      Array.isArray(filter) &&
      filter.includes("PROCESSING") &&
      !filter.includes("SHIPPING")
    ) {
      localStorage.setItem(
        ORDER_STATUS_FILTER_KEY,
        JSON.stringify([...filter, "SHIPPING"])
      );
    }
  } catch (error) {
    console.log(error);
  }
};
